import { inject, Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromStore from '../../store';

@UntilDestroy()
@Injectable()
export class SummaryFacade {
  private readonly store: Store = inject(Store);

  public consequence$: Observable<string> = this.store.select(fromStore.selectSummaryNotice);

  public onSendEmail(): void {
    this.store.dispatch(fromStore.SendEmailLoad());
  }

  public onSendRequest(): void {
    this.store.dispatch(fromStore.sendRequestActions.send());
  }
}
